import { useSelector } from "react-redux"
import { select_quote } from "src/redux/store"

export const usePrice = (discountError: string, discount?: string) => {
  const quote = useSelector(select_quote)

  const oldQuote = quote?.oldQuoteValue?.replace('.', ',')
  const newQuote = quote?.quoteValue?.replace('.', ',')

  if (discountError !== '' || !discount) {
    return `${oldQuote} €`
  }
  if (quote?.discount) {
    return 'DISCOUNT'
  }
  if (newQuote && newQuote !== '0') {
    return `${newQuote} €`
  }
  return '-'
}
